module.exports = __webpack_public_path__ + "static/media/YF84_5.36bbe7a3.jpg";